import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type AeoInvoiceStatus = z.infer<typeof aeoInvoiceStatus>;
export const aeoInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentAeoInvoice = {
  name: "getCurrentAeoInvoice" as const,
  input: z.null(),
  output: aeoInvoiceStatus.nullable(),
};
